<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg px-6">
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">{{ event.name }}</h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">{{ event.theme }}</p>
    </div>
    <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
      <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Возрастная категория</dt>
          <dd class="mt-1 text-sm text-gray-900">{{ event.age }}</dd>
        </div>
        <div class="sm:col-span-1">
          <dt class="text-sm font-medium text-gray-500">Стоимость участия</dt>
          <dd class="mt-1 text-sm text-gray-900">{{ event.cost }},00 ₽</dd>
        </div>
        <div class="sm:col-span-2">
          <!--          <dt class="text-sm font-medium text-gray-500">Аннотация</dt>-->
          <ui-json-to-html :json="event.description"/>
          <!--          <dd class="mt-1 text-sm text-gray-900" v-html="event.description">

                    </dd>-->
        </div>
        <!--        <div class="sm:col-span-2">
                  <dt class="text-sm font-medium text-gray-500">Attachments</dt>
                  <dd class="mt-1 text-sm text-gray-900">
                    <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                      <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                        <div class="w-0 flex-1 flex items-center">
                          <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true"/>
                          <span class="ml-2 flex-1 w-0 truncate"> resume_back_end_developer.pdf </span>
                        </div>
                        <div class="ml-4 flex-shrink-0">
                          <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500"> Download </a>
                        </div>
                      </li>
                      <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                        <div class="w-0 flex-1 flex items-center">
                          <PaperClipIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true"/>
                          <span class="ml-2 flex-1 w-0 truncate"> coverletter_back_end_developer.pdf </span>
                        </div>
                        <div class="ml-4 flex-shrink-0">
                          <a href="#" class="font-medium text-indigo-600 hover:text-indigo-500"> Download </a>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </div>-->
      </dl>
    </div>

    <div class="">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Управление мероприятием</h3>

        <div class="py-5" v-show="requests.length ===0 ">
          <div class="mt-2 max-w-xl text-sm text-gray-500">
            <p>Для того, чтобы принять участие в мероприятии, вам необходимо</p>
          </div>
          <div class="mt-3 text-sm">
            <ui-button @click="new_request"> подать новую заявку <span aria-hidden="true"> &rarr;</span></ui-button>
          </div>
        </div>

        <div v-for="request in requests" :key="request.id" class="cursor-pointer" @click="to_request(request.id)">
          <div class="rounded-md bg-gray-50 py-5 sm:flex sm:items-start sm:justify-between">
            <div class="sm:flex sm:items-start">
              <span
                  class="inline-flex items-center px-2.5 py-2 rounded-md text-lg font-medium bg-blue-200 text-blue-900">
                #{{ request.id }}
              </span>
              <div class="mt-3 sm:mt-0 sm:ml-4">
                <div class="text-sm font-medium text-gray-900">Заявка на участие</div>
                <div class="mt-1 text-sm text-gray-600 sm:flex sm:items-center">
                  <div>От {{ $date.formatDateLong(request.created_at) }}</div>
                  <span class="hidden sm:mx-2 sm:inline" aria-hidden="true"> &middot; </span>
                  <div class="mt-1 sm:mt-0">Изменения {{ $date.formatRelative(request.updated_at) }}</div>
                </div>
              </div>
            </div>
            <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0">
              <ui-button>Перейти</ui-button>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>


<script>

import UiJsonToHtml from "@/components/ui/form/editor/UiJsonToHtml";
import UiButton from "@/components/ui/button/UiButton";

export default {
  components: {
    UiButton,
    UiJsonToHtml,

  },
  name: "EventDetails",
  props: ['id'],
  data() {
    return {
      event: {
        name: 'Международная викторина «Путешествие по странам и континентам»',
        age: 'для 1-2 классов',
        theme: 'окружающий мир, литературное чтение',
        description: {time: null, blocks: []}

      },
      requests: []

    }
  },
  methods: {
    async new_request() {
      const request = await this.$api.user_events.store(this.id);
      this.$router.push({name: 'UserEvent', params: {id: request.id}})

    },
    to_request(id) {
      this.$router.push({name: 'UserEvent', params: {id: id}})
    }

  },

  async mounted() {
    this.event = await this.$api.events.get(this.id)
    this.requests = await this.$api.user_events.event(this.id)
  }
}
</script>

<style scoped>

</style>